import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { LaunchUrlResponse } from "../models/responses/launchUrlResponse";

export const wickets9Api = {

  /* Wickets9 game launch */
  launch9Wickets: async (): Promise<UnifiedResponse<LaunchUrlResponse>> => {
    const response = await apiClient.get<
      UnifiedResponse<LaunchUrlResponse>
      >("/game_9w/launch");

    return response.data;
  },
};